import { ModalComponent } from "@zenith/components";
import {
  ACCOUNT_RESTRICTED__TYPE,
  ACCOUNT_RESTRICTED_TITLE,
} from "@zenith/data/constants";
import { AppNavigation } from "@zenith/hooks";
import { DASHBOARD } from "@zenith/routes/paths";
import {
  ApiResponseDTOWalletBalanceInfoResponseDTO,
  WalletApiService,
} from "@zenith/services/user";
import { memo, useEffect, useState } from "react";

interface RestrictedAccountComponentPops {
  type: "payment-collection" | "send-money";
}

const RestrictedAccountComponent = memo(function RestrictedAccountComponent({
  type,
}: RestrictedAccountComponentPops) {
  const [showFreezeModal, setShowFreezeModal] = useState<boolean>(false);
  const [freezeMessage, setFreezeMessage] = useState<string>("");
  const { navigateTo } = AppNavigation();
  const handleNavigateToDashboard = () => {
    navigateTo(DASHBOARD);
  };

  const debitFreezeType = [
    ACCOUNT_RESTRICTED__TYPE.DEBIT_FREEZE,
    ACCOUNT_RESTRICTED__TYPE.TOTAL_FREEZE,
  ];

  const creditFreezeType = [
    ACCOUNT_RESTRICTED__TYPE.CREDIT_FREEZE,
    ACCOUNT_RESTRICTED__TYPE.TOTAL_FREEZE,
  ];

  const freezeType = type === "send-money" ? debitFreezeType : creditFreezeType;

  const handleGetWalletInfo = () => {
    WalletApiService.getWalletDetails()
      .then((response: ApiResponseDTOWalletBalanceInfoResponseDTO) => {
        if ("data" in response && response.data) {
          setShowFreezeModal(
            freezeType.includes(response.data.accountFreezeStatus || "")
          );
          setFreezeMessage(response.data.freezeStatusMessage || "");
        }
      })
      .catch((error) => console.error(error.message));
  };

  useEffect(() => {
    handleGetWalletInfo();
  }, []);

  const renderFreezeBody = (
    <div dangerouslySetInnerHTML={{ __html: freezeMessage }} />
  );

  return (
    <ModalComponent
      title={ACCOUNT_RESTRICTED_TITLE}
      body={renderFreezeBody}
      showModal={showFreezeModal}
      onClickButton={handleNavigateToDashboard}
      onClickClose={handleNavigateToDashboard}
      buttonText="Go Back"
    />
  );
});

export default RestrictedAccountComponent;
